<template>
  <div class="min-vh-100">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">CUSTOMER</h1>
      <b-input-group class="w-50">
        <b-form-input
          v-model="filter.search"
          placeholder="Search First Name, Last Name, Email, ID"
          @keydown.enter="handleSearch"
        />
        <b-input-group-append>
          <b-button @click="handleSearch" class="search-button">
            <font-awesome-icon icon="search" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
    <div class="mt-3 main-theme bg-white-border p-3">
      <b-table
        responsive
        striped
        hover
        class="table-list"
        :items="items"
        :fields="fields"
        :busy="isBusy"
        show-empty
        empty-text="ไม่พบข้อมูล"
      >
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(userGUID)="data">
          <div class="d-flex align-items-center">
            <b-img
              :src="data.item.imgUrl"
              v-bind="{
                blank: true,
              }"
              blank-color="#8a93a2"
              class="img-customer mr-3"
              rounded="circle"
            />
            <div>{{ data.item.userGUID }}</div>
          </div>
        </template>
        <template v-slot:cell(registedDateTime)="data">
          <span>
            {{ new Date(data.item.registedDateTime) | moment($formatDate) }}
            <br />
            ({{ new Date(data.item.registedDateTime) | moment($formatTime) }})
          </span>
        </template>
        <template v-slot:cell(id)="data">
          <b-link class="text-link" @click="onEdit(data.item.userGUID)">Edit</b-link>
        </template>
      </b-table>
      <b-row class="no-gutters px-3 px-sm-0">
        <b-col
          class="
            form-inline
            justify-content-center justify-content-sm-between
          "
        >
          <div v-if="rows > 0" class="my-auto">
            Showing {{ startPage | numeral("0,0") }} to {{ endPage | numeral("0,0") }} of {{ rows | numeral("0,0") }} entires
          </div>
          <div v-else class="my-auto">{{ rows || 0 }} entire</div>
          <div class="d-sm-flex m-3">
            <b-pagination
              v-model="filter.pageNo"
              :total-rows="rows"
              :per-page="filter.perPage"
              class="m-md-0"
              @change="pagination"
              align="center"
            ></b-pagination>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Customer",
  data: function() {
    return {
      modalMessage: "",
      bodyDelete: {
        id: 0,
      },
      isBusy: false,
      startPage: 1,
      endPage: 10,
      rows: 0,
      filter: {
        search: "",
        pageNo: 1,
        perPage: 10,
      },
      fields: [
        // {
        //   key: "imgUrl",
        //   label: "",
        //   class: "w-80px",
        // },
        {
          key: "userGUID",
          label: "ID",
          class: "w-200",
          tdClass: "text-left",
        },
        {
          key: "firstName",
          label: "First Name",
          class: "w-100px",
        },
        {
          key: "lastName",
          label: "Last Name",
          class: "w-100px",
        },
        // {
        //   key: "satisfactionScore",
        //   label: "Satisfaction Score",
        //   class: "w-180px",
        // },
        {
          key: "email",
          label: "Email",
          class: "w-100px",
        },
        {
          key: "registedDateTime",
          label: "Registed Date",
          class: "w-100px",
        },
        // {
        //   key: "lastUpdatedDateTime",
        //   label: "Last Update Date",
        //   class: "w-160px",
        // },
        {
          key: "id",
          label: "",
          class: "w-80px",
        },
      ],
      items: [],
    };
  },

  created: async function() {
    await this.getList();
    this.getShowingPage(this.filter.pageNo);
  },
  methods: {
    getList: async function() {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/customer/list`, this.filter)
        .then((data) => {
          if (data.result == 1) {
            this.items = data.detail.data;
            this.rows = data.detail.total;
          }
        });
      this.isBusy = false;
    },
    async handleSearch (){
      this.pagination(1);
    },
    onEdit(userGUID) {
      this.$router.push({ path: `/customer/detail/${userGUID}` }).catch(() => {});
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      this.getList();
      this.getShowingPage(Page);
    },
    getShowingPage(Page) {
      const totalRow = this.rows;
      this.startPage = (Page - 1) * this.filter.perPage + 1;
      if (Page * this.filter.perPage <= totalRow) {
        this.endPage = Page * this.filter.perPage;
      } else {
        this.endPage = totalRow;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.create-button {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  font-size: 14px;
  padding: 0.375rem 0.75rem;
  background-color: #5b57a5;
  color: #ffffff !important;
  border-radius: 4px;
  border: none;
}
::v-deep .text-link {
  text-decoration: underline;
  color: #0062ff;
}
::v-deep .text-link.disabled {
  opacity: 0.6;
  cursor: default !important;
}
.img-customer {
  width: 55px;
  height: 55px;
}
.f-red {
  color: #F55D67;
}
.f-yellow {
  color: #FFCE2B;
}
.f-green {
  color: #27BDA7;
}
</style>
